import React, { Component } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core/";

import { xencallService } from "../services";

class Subscriptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptions: []
    };
  }

  componentDidMount() {
    const { client } = this.props;
    console.log("Subscriptions - componentDidMount() - client", client);
    if (client && client.stripeId) {
      xencallService.getSubscriptions(this, client.stripeId);
    }
  }

  formatDate(ts) {
    const d = new Date(ts * 1000);
    console.log(d);
    console.log(d.toLocaleDateString());
    return d.toLocaleDateString();
  }

  render() {
    const { client } = this.props;
    const { subscriptions } = this.state;

    console.log("Subscriptions client", client);
    console.log("Subscriptions subscriptions", subscriptions);

    return (
      <div>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>End</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subscriptions.map(subscription => (
              <TableRow key={subscription.id}>
                <TableCell>{subscription.id}</TableCell>
                <TableCell>
                  {this.formatDate(subscription.current_period_start)}
                </TableCell>
                <TableCell>
                  {this.formatDate(subscription.current_period_end)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export { Subscriptions };
